export var capitalizeCityState = function (cityState) {
    if (!cityState)
        return '';
    var cityStateArr = cityState.split(', ');
    return "".concat(cityStateArr[0]
        .split(' ')
        .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(); })
        .join(' '), ", ").concat(cityStateArr[1]);
};
